export const PARALLAX_OPTIONS = {
  offsetCoefficient: 0.3,
  containerOffsetCoefficient: 0.15,
};
